module.exports = __webpack_public_path__ + "static/media/featureIcon3.8fbf61c8.png";